import { Link } from "react-router-dom";
import { catLabel } from "../lib/api";

export const Marquee = ({ items = [] }) => {
  if (!items.length) return null;
  const row = [...items, ...items];
  return (
    <section className="marquee bg-hot text-ink border-y-2 border-ink overflow-hidden py-5" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center">
        {row.map((a, i) => (
          <Link key={`${a.slug}-${i}`} to={`/article/${a.slug}`} className="flex items-center shrink-0 group" data-testid={`marquee-item-${i}`}>
            <span className="kicker mr-4 opacity-80">{catLabel(a.category)}</span>
            <span className="display text-4xl sm:text-5xl group-hover:text-cream transition-colors">{a.title}</span>
            <svg viewBox="0 0 24 24" className="h-8 w-8 mx-10 shrink-0" aria-hidden="true">
              <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" fill="#1B1215" />
            </svg>
          </Link>
        ))}
      </div>
    </section>
  );
};
